import { useQuery } from "@tanstack/react-query";
import { ApiService } from "@/services/api/ApiService";
import { Agent } from "@/types/agent/agent";

interface SetupAgentsResponse {
  general: Agent | null;
}

export const useSetupAgent = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: ["setup-agents"],
    queryFn: () => ApiService.callEdge<SetupAgentsResponse>("handle-agent", { action: "setup-agents" }),
    staleTime: 24 * 60 * 60 * 1000,
    gcTime: 7 * 24 * 60 * 60 * 1000,
    refetchOnWindowFocus: false,
  });

  return {
    agent: data?.general ?? null,
    isLoading,
    error: error?.message ?? null,
  };
};
